// src/utils/apiSettings.js

export const apiSettings = {
  serverName: process.env.REACT_APP_API_URL || "http://localhost:5000",
  localServer: "https://deliveryapi.hosfatantabolis.ru",
};

export default apiSettings;
